module.exports = __webpack_public_path__ + "static/Anbaugebiet-Sachsen-800x685-c067740fff1651a6ee2ecdbbbb531310.jpeg";